@if (showTitle()) {
<div data-testid="internal-after-header" class="px-6 py-6 pb-0">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3">
    {{ 'after.internal.title' | translate }}
  </h2>
</div>
}
<router-outlet data-testid="internal-after-router-outlet"></router-outlet>
